<div class="c-chat-box__item-slider">
  <div class="surf-option-slider">
    <div class="surf-option-slider__viewer">
      <button class="a-btn surf-option-slider__nav-btn surf-option-slider__nav-btn--left"
              (click)="slide(SLIDER_DIRECTIONS.LEFT)">
        <svg class="a-icon">
          <use xlink:href="#previous"></use>
        </svg>
      </button>
      <div class="surf-option-slider__frame" #sliderFrame>
        <div class="surf-option-slider__item"
             *ngFor="let hotel of content; let i = index">
          <div class="c-chat-box__info-card">
            <div class="c-chat-box__info-card-header">
              <div class="c-chat-box__info-card-title-block">
                <span class="s-strong c-chat-box__info-card-title">{{ hotel.name }}</span>
                <div class="c-chat-box__info-card-tags">
<!--                  <span class="a-loz a-loz&#45;&#45;light/info">Dynamic</span>-->
                  <span class="a-loz a-loz--light/success" *ngIf="hotel.availability">AV</span>
                </div>
              </div>
              <div class="c-chat-box__info-card-info-block">
                <div class="c-chat-box__info-card-info-item">
                  <svg class="a-icon u-x1.25 tc-ash">
                    <use xlink:href="#map"></use>
                  </svg>
                  <span class="cap-strong">{{ hotel.address }}</span>
                </div>
                <div class="c-chat-box__info-card-info-item" *ngIf="hotel.starRating">
                  <svg class="a-icon u-x1.5 tc-warning">
                    <use xlink:href="#star"></use>
                  </svg>
                  <span class="cap-strong">{{ hotel.starRating }} Star</span>
                </div>
              </div>
            </div>
            <div class="c-chat-box__info-card-body">
              <div class="c-chat-box__info-card-details">
                <div class="c-chat-box__info-card-detail-item">
                  <span class="cap tc-muted">Room</span>
                  <span class="s-strong">{{ hotel.cheapestRoomType }}</span>
                </div>
                <div class="c-chat-box__info-card-detail-item">
                  <span class="cap tc-muted">Meal plan</span>
                  <span class="s-strong">{{ hotel.cheapestMealPlan }}</span>
                </div>
              </div>
              <div class="c-chat-box__info-card-pricing">
                <span class="cap tc-muted">from</span>
                <div class="c-chat-box__info-card-price">
                  <span class="cap-strong tc-success">
                    {{ hotel.nonRefundable ? '(Non-Refundable)' : '(Refundable)' }}
                  </span>

                  <span class="s-lg-strong">{{ hotel.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="a-btn surf-option-slider__nav-btn surf-option-slider__nav-btn--right"
              (click)="slide(SLIDER_DIRECTIONS.RIGHT)">
        <svg class="a-icon">
          <use xlink:href="#next"></use>
        </svg>
      </button>
    </div>
  </div>
</div>
